import SectionHeading from "@/components/base/SectionHeading";

const promises = [
  {
    icon: "ri-lock-2-line",
    title: "身份默认加密",
    desc: "投稿人信息与线索内容分开存储，默认状态为加密。除了核实小组，没有第三方能接触到原始身份记录。",
  },
  {
    icon: "ri-file-shield-2-line",
    title: "材料只在内部流转",
    desc: "你提交的截图、聊天记录与文件仅用于核实，不会外传、不会用于任何商业用途，也不授权给其他机构。",
  },
  {
    icon: "ri-user-forbid-line",
    title: "发布前统一匿名化",
    desc: "对外发布时会对头像、昵称、订单号等可识别信息打码，涉及的时间与称谓也可能被模糊处理。",
  },
  {
    icon: "ri-arrow-go-back-line",
    title: "可撤回、可更正",
    desc: "发布前你随时可以撤回材料；发布后若发现事实性错误，我们会在原页面显著位置发布更正说明。",
  },
];

export default function PrivacyPromise() {
  return (
    <section className="bg-secondary-50">
      <div className="mx-auto w-full max-w-shell px-4 py-14 md:px-6 md:py-20">
        <SectionHeading
          eyebrow="隐私与安全"
          title="降低曝光风险，是我们最在意的事"
          desc="很多提供线索的人并不想被认出来。我们把这四件事写进流程，而不是只放在口号里。"
        />

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2">
          {promises.map((item) => (
            <div
              key={item.title}
              className="flex items-start gap-4 rounded-lg border border-secondary-200 bg-background-50 p-5 md:p-6"
            >
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-secondary-500 text-background-50">
                <i className={`${item.icon} text-xl`} aria-hidden="true"></i>
              </span>
              <div>
                <h3 className="font-heading text-base font-semibold text-foreground-950 md:text-lg">
                  {item.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}